module.exports = __webpack_public_path__ + "media/promo/hochland/images/snow-3dd0508d7a336e31cdcc852fcf35c686.png";